import React from 'react';
import { Typography } from '@mui/material';
import { clearUserSessionTimers, useActivateUserSessionTimers } from '../../common/utils/userSessionTimers';
import { UserSessionTimeoutMessageStyles } from '../styles/userSessionTimeoutMessage';
import { useTranslation } from 'react-i18next';
import { DialogBox } from '../../common/components/DialogBox';
import { useAppSelector } from '../../store/hook';
import { basicDetailsProvider } from '../../store/providers/basicDetailsProvider';
import { WCAGStrandardStyles } from '../../common/styles/WCAGStandardStyles';

const UserSessionTimeoutMessage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { updateIsUserInactive } = basicDetailsProvider();
  const candidate = useAppSelector((state) => state.candidate);
  const activateUserSessionTimers = useActivateUserSessionTimers();
  const { classes } = UserSessionTimeoutMessageStyles();
  const { classes: WCAGClasses } = WCAGStrandardStyles();
  const handleContinueSession = (): void => {
    console.info('[USER ACTIVE]: RESTARTING SESSION TIMERS');
    updateIsUserInactive(false);
    clearUserSessionTimers();
    activateUserSessionTimers();
  };

  return (
    <DialogBox buttonText={t('continue')} onSubmit={handleContinueSession}>
      <Typography color="inherit" variant="h1" align="center" className={classes.title}>
        {t('sessionExpireTitle', { firstName: candidate ? candidate.firstName : '' })}
      </Typography>
      <Typography color="inherit" align="center" className={`${classes.content} ${WCAGClasses.h3}`}>
        {t('sessionExpireMsg')}
      </Typography>
    </DialogBox>
  );
};

export default UserSessionTimeoutMessage;
